import React, { useEffect } from "react";
import "./vcView.scss";
import useDebounce from "../../common/debounce";
import VCAgeWiseView from "./VCAgeWiseView";

const VCView = (props) => {
  const {
    appointmentData,
    vaccineList,
    patientDob,
    generalVaccineList,
    isAgeAboveSixteen,
    vitalsList,
    searchVaccine,
    updatedGender,
    vaccineNotes,
    prescription_id,
    addEditVitals,
    patientDetails,
    prescriptionVitals,
    setVaccineList,
    setGeneralVaccineList,
    setSearchVaccine,
    setLoader,
    fetchVitals,
    getVaccines,
    handleVaccineNotes,
    handleUpdateAPICall,
  } = props;

  const debounceForVaccineNotes = useDebounce(vaccineNotes, 500);

  // Lifecycle Methods ===>

  useEffect(() => {
    if (debounceForVaccineNotes?.call_api) {
      handleUpdateAPICall();
    }
  }, [debounceForVaccineNotes]);

  useEffect(() => {
    vaccineList.forEach((item) => {
      item.show =
        item.vaccines.filter((ele) =>
          ele.name?.toLowerCase().includes(searchVaccine?.toLowerCase())
        )?.length !== 0;
    });
    setVaccineList([...vaccineList]);
    generalVaccineList.forEach((item) => {
      item.show =
        item.vaccines.filter((ele) =>
          ele.name?.toLowerCase().includes(searchVaccine?.toLowerCase())
        )?.length !== 0;
    });
    setGeneralVaccineList([...generalVaccineList]);
  }, [searchVaccine]);

  // <===

  return (
    <div className="vc-container">
      <VCAgeWiseView
        appointmentData={appointmentData}
        vaccineList={vaccineList}
        patientDob={patientDob}
        generalVaccineList={generalVaccineList}
        isAgeAboveSixteen={isAgeAboveSixteen}
        updatedGender={updatedGender}
        vaccineNotes={vaccineNotes}
        vitalsList={vitalsList}
        prescription_id={prescription_id}
        addEditVitals={addEditVitals}
        prescriptionVitals={prescriptionVitals}
        searchVaccine={searchVaccine}
        patientDetails={patientDetails}
        setSearchVaccine={setSearchVaccine}
        handleVaccineNotes={handleVaccineNotes}
        setVaccineList={setVaccineList}
        setLoader={setLoader}
        setGeneralVaccineList={setGeneralVaccineList}
        getVaccines={getVaccines}
        fetchVitals={fetchVitals}
      />
    </div>
  );
};

export default VCView;
